<template>
    <div style="height: 100%">
        <nav
            v-if="$route.name && !$route.name.includes('External')"
            class="navbar navbar-expand-xxl fixed-top"
            :class="
                isdarktheme ? ['navbar_dark', 'navbar-dark'] : 'navbar_light'
            "
        >
            <div class="container-fluid">
                <button
                    id="navbarCollapser"
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="d-xxl-none d-block">
                    <div v-if="!alive_signal">Buscando status da farm...</div>
                    <div v-else class="row align-items-center">
                        <div class="col-3">
                            <div
                                class="spinner-grow"
                                :class="
                                    render_server_active
                                        ? 'text-success'
                                        : 'text-danger'
                                "
                                role="status"
                            >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <a
                    class="navbar-brand px-2 d-flex d-xxl-none pointer"
                    @click="isdarktheme = !isdarktheme"
                    ><svg
                        v-if="!isdarktheme"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-brightness-high"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                        />
                    </svg>
                    <svg
                        v-else
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-moon-stars"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"
                        />
                        <path
                            d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
                        />
                    </svg>
                </a>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <div class="d-xxl-flex">
                            <li
                                v-for="(item, key) of navbar"
                                :key="key"
                                class="nav-item"
                            >
                                <router-link
                                    @click="clickCollapse"
                                    class="nav-link"
                                    :class="
                                        ('' + $route.name).includes(item.page)
                                            ? 'active'
                                            : ''
                                    "
                                    :to="{
                                        name: item.page,
                                        params: {
                                            idproject: $route.params.idproject,
                                        },
                                    }"
                                    >{{ item.title }}</router-link
                                >
                            </li>
                        </div>
                        <li class="d-xxl-none nav-link">
                            <a
                                class="dropdown-item pointer text-center"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#projectModal"
                                >Trocar de projeto
                            </a>
                        </li>
                        <li
                            class="nav-item dropdown d-block d-xxl-none align-self-center"
                        >
                            <a
                                class="nav-link dropdown-toggle"
                                href="#"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Projeto: {{ project_selected?.name }}
                            </a>
                            <ul
                                class="dropdown-menu dropdown-menu-end container py-0"
                            >
                                <li v-if="permission_to_buffer">
                                    <a class="dropdown-item"
                                        >Scripts pendentes de storyboard:
                                        {{ project_selected.storyboardscript }}
                                    </a>
                                </li>
                                <li v-if="permission_to_buffer">
                                    <a class="dropdown-item"
                                        >Storyboards pendentes de render:
                                        {{ project_selected.renderstoryboard }}
                                    </a>
                                </li>
                                <li v-if="permission_to_buffer">
                                    <a class="dropdown-item"
                                        >Renders pendentes de aprovação:
                                        {{ project_selected.approvalrender }}
                                    </a>
                                </li>
                                <li v-if="permission_to_buffer">
                                    <hr class="dropdown-divider my-0" />
                                </li>
                                <li class="d-none d-xxl-block">
                                    <router-link
                                        v-if="$store.state?.auth?.user?.login"
                                        class="dropdown-item pointer text-center"
                                        type="button"
                                        to="user"
                                        >Minha página
                                    </router-link>
                                </li>
                                <li
                                    class="d-none d-xxl-block"
                                    v-if="$store.state?.auth?.user?.login"
                                >
                                    <hr class="dropdown-divider my-0" />
                                </li>
                            </ul>
                        </li>
                        <li>
                            <router-link
                                v-if="$store.state?.auth?.user?.login"
                                class="nav-link d-xxl-none"
                                type="button"
                                :to="{
                                    name: 'UserPage',
                                    params: {
                                        id: $store.state.auth?.user?.member
                                            ?.idbasecamp,
                                    },
                                }"
                                >Minha página
                            </router-link>
                        </li>

                        <li
                            class="nav-link d-xxl-none"
                            v-if="
                                project_selected &&
                                $store.state?.auth?.user?.login &&
                                $store.state?.auth?.user?.member?.admin
                            "
                        >
                            <router-link
                                class="dropdown-item pointer text-center"
                                :to="{
                                    name: 'ExternalConfigurationPage',
                                }"
                                type="button"
                                >Configurar Dashboard
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div v-if="project_selected" class="d-none d-xxl-block">
                    <div id="navbarSupportedContent">
                        <ul class="navbar-nav me-auto mb-2 mb-xxl-0">
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Projeto: {{ project_selected.name }}
                                </a>
                                <ul
                                    class="dropdown-menu dropdown-menu-end py-0"
                                >
                                    <li v-if="permission_to_buffer">
                                        <a class="dropdown-item no-hover-effect"
                                            >Scripts pendentess de storyboard:
                                            {{
                                                project_selected.storyboardscript
                                            }}
                                        </a>
                                    </li>
                                    <li v-if="permission_to_buffer">
                                        <a class="dropdown-item no-hover-effect"
                                            >Storyboards pendentes de render:
                                            {{
                                                project_selected.renderstoryboard
                                            }}
                                        </a>
                                    </li>
                                    <li v-if="permission_to_buffer">
                                        <a class="dropdown-item no-hover-effect"
                                            >Renders pendentes de aprovação:
                                            {{
                                                project_selected.approvalrender
                                            }}
                                        </a>
                                    </li>
                                    <li v-if="permission_to_buffer">
                                        <hr class="dropdown-divider my-0" />
                                    </li>
                                    <li>
                                        <router-link
                                            v-if="
                                                $store.state?.auth?.user?.login
                                            "
                                            class="dropdown-item pointer text-center"
                                            :to="{
                                                name: 'UserPage',
                                                params: {
                                                    id: $store.state.auth?.user
                                                        ?.member?.idbasecamp,
                                                },
                                            }"
                                            type="button"
                                            >Minha página
                                        </router-link>
                                    </li>
                                    <li v-if="$store.state?.auth?.user?.login">
                                        <hr class="dropdown-divider my-0" />
                                    </li>
                                    <li>
                                        <a
                                            class="dropdown-item pointer text-center"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#projectModal"
                                            >Trocar de projeto
                                        </a>
                                    </li>
                                    <li
                                        v-if="
                                            $store.state?.auth?.user?.login &&
                                            $store.state?.auth?.user?.member
                                                ?.admin
                                        "
                                    >
                                        <hr class="dropdown-divider my-0" />
                                    </li>
                                    <li
                                        v-if="
                                            $store.state?.auth?.user?.login &&
                                            $store.state?.auth?.user?.member
                                                ?.admin
                                        "
                                    >
                                        <router-link
                                            class="dropdown-item pointer text-center"
                                            :to="{
                                                name: 'ExternalConfigurationPage',
                                            }"
                                            type="button"
                                            >Configurar Dashboard
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <a
                                class="navbar-brand d-none d-xxl-flex align-self-center ps-3 pointer"
                                @click="isdarktheme = !isdarktheme"
                                ><svg
                                    v-if="!isdarktheme"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-brightness-high"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                                    />
                                </svg>
                                <svg
                                    v-else
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-moon-stars"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"
                                    />
                                    <path
                                        d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
                                    />
                                </svg>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        <router-view v-if="authenticated && !is_loading && project_selected" />
        <div v-else-if="authenticated && !is_loading && !project_selected">
            <ProjectSelectComponent
                :projects_parent="projects"
                :isdarktheme="isdarktheme"
                @updateProject="updateProject"
            />
        </div>
        <div v-if="!authenticated && !is_loading">
            <LoginComponent
                :isdarktheme="isdarktheme"
                @updateLoading="updateLoading"
            />
        </div>
        <div v-if="is_loading" class="window-centered">
            <div
                class="spinner-border"
                :style="isdarktheme ? 'color: #ddd' : ''"
            />
        </div>
        <div
            class="modal fade"
            id="projectModal"
            tabindex="-1"
            aria-labelledby="projectModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div
                    class="modal-content"
                    :class="isdarktheme ? 'bg_dark' : ''"
                >
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="projectModalLabel">
                            Selecione o projeto
                        </h1>
                        <button
                            type="button"
                            class="btn-close"
                            :class="isdarktheme ? 'bg-light' : ''"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div
                            v-for="(project, key) of projects"
                            :key="key"
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                :name="'radio_project_' + project?.idbasecamp"
                                :id="'radio_project_' + project?.idbasecamp"
                                :disabled="
                                    project?.idbasecamp ==
                                    project_selected?.idbasecamp
                                "
                                v-model="aux_project_selected"
                                :value="project"
                            />
                            <label
                                class="form-check-label"
                                :for="'radio_project_' + project.idbasecamp"
                            >
                                {{ project.name }}
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            :disabled="!aux_project_selected"
                            type="button"
                            @click="changeProject"
                            class="btn btnConfirm"
                            data-bs-dismiss="modal"
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        class="server-info p-2 rounded-start d-none d-xxl-block"
        :class="isdarktheme ? ['bg_dark', 'shadow_dark'] : 'bg-light'"
    >
        <div v-if="!alive_signal">Buscando status da farm...</div>
        <div v-else class="row align-items-center">
            <div class="col-1">
                <div
                    class="spinner-grow"
                    :class="
                        render_server_active ? 'text-success' : 'text-danger'
                    "
                    role="status"
                >
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="col">
                Farm está {{ render_server_active ? "ativa" : "inativa" }}
            </div>
        </div>
    </div>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import ProjectService from "@/services/ProjectService";
import LoginComponent from "./components/LoginComponent.vue";
import StatusService from "./services/StatusService";
import ProjectSelectComponent from "./components/ProjectSelectComponent.vue";
import { Tooltip } from 'bootstrap/dist/js/bootstrap'
export default {
    name: "App",
    components: {
        LoginComponent,
        ProjectSelectComponent,
    },
    data() {
        return {
            authenticated: false,
            login: "",
            email: "",
            password: "",
            passwordToRegister: "",
            service: DashboardService,
            project_service: ProjectService,
            serviceStatus: StatusService,
            is_loading: false,
            isProjectSelected: false,
            projects: [],
            project_selected: null,
            permission_to_buffer: false,
            aux_project_selected: null,
            navbar: [],
            render_server_active: false,
            alive_signal: false,
            isdarktheme: false,
        };
    },
    methods: {
        clickCollapse() {
            if (window.innerWidth < 992) {
                let btn_collapse = document.getElementById("navbarCollapser");
                btn_collapse.click();
            }
        },
        updateProject(project) {
            this.project_selected = project;
            let idproject = this.project_selected.idbasecamp;
            this.service.getWebPages(idproject).then((res) => {
                this.navbar = res.data.navbar;
                for (let permission of res.data.access) {
                    if (permission.page == "BufferPage") {
                        this.permission_to_buffer = true;
                    }
                }
            });
            this.$router.push({
                name: "ExternalHomePage",
                params: {
                    idproject: this.project_selected.idbasecamp,
                },
            });
        },
        updateLoading(status) {
            this.is_loading = status;
        },
        checkUpdateOnLogin() {
            if (
                this.$store.state?.auth?.user?.member == null &&
                this.$store.state?.auth?.user?.login
            ) {
                localStorage.clear();
                document.location.reload();
            }
        },
        getNavbar() {
            if (this.project_selected) {
                let idproject = this.project_selected.idbasecamp;
                this.service.getWebPages(idproject).then((res) => {
                    this.navbar = res.data.navbar;
                    for (let permission of res.data.access) {
                        if (permission.page == "BufferPage") {
                            this.permission_to_buffer = true;
                        }
                    }
                });
            }
            this.is_loading = false;
        },
        getProjects() {
            this.is_loading = true;
            setTimeout(() => {
                let idproject = this.$route.params.idproject;
                this.project_service
                    .getAllAvailable()
                    .then((res) => {
                        this.projects = res.data;
                        this.project_selected = null;
                        for (let project of this.projects) {
                            if (project.idbasecamp == idproject) {
                                this.project_selected = project;
                                break;
                            }
                        }
                    })
                    .finally(() => {
                        this.getNavbar();
                    });
            }, 100);
        },
        changeProject() {
            this.updateProject(this.aux_project_selected);
        },
        checkLogin() {
            if (this.$store.state.auth?.user?.login != null) {
                this.authenticated = true;
                this.getProjects();
            } else {
                this.$router.push({
                    name: "ExternalHomePage",
                    params: { idproject: "login" },
                });
            }
        },
        checkRenderServerStatus() {
            this.serviceStatus.getStatus().then((res) => {
                if (res != null) {
                    this.render_server_active = res?.data;
                    this.alive_signal = true;
                } else {
                    this.alive_signal = false;
                }
            });
        },
        checkProject() {
            let idproject = this.$route.params.idproject;
            if (idproject) {
                this.project_service.getById(idproject).then((res) => {
                    if (res.data && res.data.idbasecamp == idproject) {
                        this.idproject == idproject;
                    }
                });
            }
        },
        updateBuffer(payload) {
            this.project_selected.approvalrender = payload.approvalrender;
            this.project_selected.renderstoryboard = payload.renderstoryboard;
            this.project_selected.storyboardscript = payload.storyboardscript;
        },
    },
    created() {
        document.title = "Oppai-Man Dashboard";
        new Tooltip(document.body, {
            selector: "[class='tooltipElement']",
        });
        this.checkUpdateOnLogin();
        this.checkLogin();
        this.checkRenderServerStatus();
        setInterval(() => {
            this.checkRenderServerStatus();
        }, 120000);
        if (this.$store.state?.configs?.config?.darktheme != null) {
            this.isdarktheme = this.$store.state.configs.config.darktheme;
        } else {
            if (
                window.matchMedia &&
                window.matchMedia("(prefers-color-scheme: dark)").matches
            ) {
                this.isdarktheme = true;
            }
        }
    },
    mounted() {
        let chartJs = document.createElement("script");
        chartJs.setAttribute("src", "https://cdn.jsdelivr.net/npm/chart.js");
        document.head.appendChild(chartJs);
        this.$moment.locale("pt-br");
    },
    watch: {
        isdarktheme(val) {
            let config = {
                darktheme: val,
            };
            localStorage.setItem("config", JSON.stringify(config));
            this.$store.commit("configs/changeConfigs");
            let bg = document.getElementsByTagName("html")[0];
            if (val) {
                bg.style.backgroundColor = "rgb(20,30,35)";
            } else {
                bg.style.backgroundColor = "#F2EDEB";
            }
        },
    },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
html {
    background-color: #f2edeb;
    height: 100%;
}
body {
    background-color: inherit !important;
    height: 100%;
}
#app {
    font-family: "Rubik", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
}
.window-centered {
    position: absolute !important;
    width: 100% !important;
    top: 35% !important;
    z-index: 1 !important;
}
.spinner-border {
    --bs-spinner-width: 10rem;
    --bs-spinner-height: 10rem;
    --bs-spinner-border-width: 1rem;
    border-right-color: transparent;
}
.pointer {
    cursor: pointer;
}
.font-rubik {
    font-family: "Rubik", sans-serif;
}
.server-info {
    position: fixed;
    bottom: 15px;
    right: -8.5rem;
    width: 10rem;
    box-shadow: 3px 3px 10px#DFD2CE;
}
.server-info:hover {
    transition: all 250ms;
    right: 0px;
}
.navbar_light {
    background-color: rgba(255, 255, 255, 0.75);
}
.navbar_light .no-hover-effect:hover {
    background-color: rgba(0, 0, 0, 0) !important;
}
.navbar_light .dropdown-menu,
.navbar_dark .dropdown-menu {
    border-radius: 0;
}
.navbar_dark,
.navbar_dark .dropdown-menu {
    background-color: rgba(32, 48, 56, 0.75) !important;
}
.navbar_dark .dropdown-item:hover {
    color: white !important;
    background-color: rgb(20, 30, 35);
}
.navbar_dark .no-hover-effect:hover {
    background-color: rgba(0, 0, 0, 0) !important;
}
.navbar_dark a {
    color: rgb(209, 208, 208);
}
.navbar_dark .navbar-nav .nav-link.active,
.navbar_dark .nav-link .dropdown-toggle .show,
.navbar_dark a:hover {
    color: white;
}
.bg_dark {
    color: white !important;
    background-color: rgb(32, 48, 56) !important;
}
.shadow_dark {
    box-shadow: 3px 3px 10px rgb(20, 30, 35) !important;
}
.btnConfirm {
    color: white !important;
    border: 1px solid #44af69 !important;
    background-color: #44af69 !important;
}
.bg_dark > .modal-header,
.bg_dark > .modal-footer {
    border-color: #2c3e50 !important;
}
.tooltipElement {
    position: relative;
    display: inline-block;
}
.tooltip-inner {
    white-space: pre-wrap;
}

.form-select:disabled {
    background-color: #ccc !important;
}
</style>
<style scoped>
.spinner-grow {
    --bs-spinner-width: 1rem;
    --bs-spinner-height: 1rem;
}
</style>